// Infinite scroll for collection product grid and search results grid.
// Can be triggered either by observer or button click. The trigger is an
// <a href="?page=N"> (crawlable by Googlebot); JS intercepts the click and
// AJAX-loads in place. After each successful fetch we replaceState() the
// URL bar so deep pages have real URLs (sharing, back-button, SEO parity
// with Google's pagination guidance).
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('a, button');
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.fetchNextPage();
    });
    this.nextUrl = this.dataset.nextUrl;
    this.isFetching = false; // Flag to track fetch status

    if (this.dataset.triggerType === 'infinite') {
      this.initObserver();
    }
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fetchNextPage();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(this);
  }

  async fetchNextPage() {
    if (this.isFetching) return; // Prevent fetch if already in progress

    this.isFetching = true; // Set flag to true
    this.button.classList.add('loading');
    this.querySelector('.loading-overlay').classList.remove('hidden');

    fetch(this.nextUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const documentProductGrid = document.getElementById('product-grid-ajax'),
              documentPagination = document.getElementById('pagination-ajax'),
              html = new DOMParser().parseFromString(responseText, 'text/html'),
              fetchProductGrid = html.getElementById('product-grid-ajax'),
              fetchPagination = html.getElementById('pagination-ajax'),
              banners = fetchProductGrid.querySelectorAll('.card--banner');

        banners.forEach(function(banner) {
          fetchProductGrid.removeChild(banner);
        });

        documentProductGrid.insertAdjacentHTML('beforeend', fetchProductGrid.innerHTML);
        documentPagination.innerHTML = fetchPagination.innerHTML;

        // a11y: announce that more products loaded + move focus to the next-page link so
        // keyboard users continue from where they were rather than being jumped to top. WCAG 4.1.2 / 2.4.3.
        let liveRegion = document.getElementById('facet-results-status');
        if (!liveRegion) {
          liveRegion = document.createElement('p');
          liveRegion.id = 'facet-results-status';
          liveRegion.className = 'visually-hidden';
          liveRegion.setAttribute('role', 'status');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('tabindex', '-1');
          document.body.prepend(liveRegion);
        }
        liveRegion.textContent = (window.themeStrings && window.themeStrings.products_loaded) || 'More products loaded.';
        const nextLink = documentPagination.querySelector('a[rel="next"]');
        if (nextLink) nextLink.focus({ preventScroll: true });

        // Reflect the just-loaded page in the URL bar so deep pages have real
        // URLs (back/forward, sharing, and parity with the canonical we emit).
        window.history.replaceState({}, '', this.nextUrl);

        // Save the whole collection div for back button usage
        const content = document.getElementById('collection-ajax').innerHTML;
        sessionStorage.setItem('pageContent', content);
        sessionStorage.setItem('pageContentURL', window.location.href);

      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.isFetching = false; // Reset flag after fetch completes
        this.button.classList.remove('loading');
        this.querySelector('.loading-overlay').classList.add('hidden');
      });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);

// Load content from local storage logic
(() => {
  // Back button detection
  if (performance.navigation.type !== 2) {
    return;
  }

  const contentURL = sessionStorage.getItem('pageContentURL');

  // URL of the content must mach wiht the page
  if (window.location.href !== contentURL) {
    return;
  }

  const content = sessionStorage.getItem('pageContent');
  if (content) {
      document.getElementById('collection-ajax').innerHTML = content;
  }
})();